import React from 'react';
import { BellIcon } from 'lucide-react';
import { channel } from '../data/channel';
interface SubscribeButtonProps {
  size?: 'sm' | 'lg';
  variant?: 'ember' | 'ink';
  label?: string;
}
export function SubscribeButton({
  size = 'sm',
  variant = 'ember',
  label = 'Підписатися'
}: SubscribeButtonProps) {
  const sizing = size === 'lg' ? 'h-14 px-7 text-base gap-2.5' : 'h-10 px-4 text-sm gap-2';
  const colors = variant === 'ember' ? 'bg-ember text-ember-ink hover:bg-ember-hover' : 'bg-ink text-paper hover:bg-raised';
  return <a href={channel.subscribeUrl} target="_blank" rel="noopener noreferrer" className={`inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full font-bold transition-[background-color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember ${sizing} ${colors}`} data-id="element-154" data-mp="1qrqzdnh8uljy">
      <BellIcon className={size === 'lg' ? 'h-5 w-5' : 'h-4 w-4'} aria-hidden="true" data-id="element-155" data-mp="3bhic4nwkrm7a" />
      {label}
    </a>;
}